import { render, staticRenderFns } from "./KucunList.vue?vue&type=template&id=9bc5142e&scoped=true&"
import script from "./KucunList.vue?vue&type=script&lang=js&"
export * from "./KucunList.vue?vue&type=script&lang=js&"
import style1 from "./KucunList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc5142e",
  null
  
)

export default component.exports